import React from "react";
import { useState } from "react";
import "./ExecutionAndDocumentationMobileView.css";
import ExecutionAndDocumentationMobileStep1 from "./ExecutionAndDocumentationMobileStep1";
import ExecutionAndDocumentationMobileStep2 from "./ExecutionAndDocumentationMobileStep2";
import ExecutionAndDocumentationMobileStep3 from "./ExecutionAndDocumentationMobileStep3";
import ExecutionAndDocumentationMobileStep4 from "./ExecutionAndDocumentationMobileStep4";
import ExecutionAndDocumentationMobileStep5 from "./ExecutionAndDocumentationMobileStep5";
import { useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";

function ExecutionAndDocumentationMobileView() {
  const steps = [1, 2, 3, 4, 5];
  const [orderRelocation, setOrderRelocation] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);

    getDocument();

    const storedToken = JSON.parse(localStorage.getItem("accessToken"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}customerget/GetCustomerOrderSummary?relocation_id=` +
            Relocation_ID,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setOrderRelocation(response.data.data[0]);
          
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const [rows, setRows] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const location = useLocation();
  const [documentResponse, setDocumentResponse] = useState(null);

  const handleNext = () => {
    if (currentStep < steps.length) setCurrentStep(currentStep + 1);
  };

  const handlePrev = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const searchParams = new URLSearchParams(location.search);
  const encryptedRelocationID = searchParams.get("ID");
  const Relocation_ID = decryptRelocationID(encryptedRelocationID);

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);

      return null;
    }
  }

  function getDocument() {
    const storedToken = JSON.parse(localStorage.getItem("accessToken"));
    if (storedToken) {
      axios
        .get(
          `${baseAPI}customerget/GetCustomerDocumentsDetail?relocation_id=` +
            Relocation_ID +
            `&option=1&is_submit=1&documentTypeId=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setDocumentResponse(response.data.data);
            const data = response.data?.data || [];
            setRows(data);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  const formatDate = (dateString) => {
    const options = {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    const formattedDate = new Date(dateString).toLocaleString("en-US", options);
    return formattedDate;
  };

  // Styles
  const rowColorChange = (index) => ({
    backgroundColor: index % 2 === 0 ? "#f6f3ff" : "white",
    color: "black",
  });

  return (
    <div style={{ backgroundColor: "white" }} className="main px-3 py-4">
      <div className="">
        <h1 style={{ fontSize: "20px" }} className="heading mb-4 m-0">
          Execution & Documentation
        </h1>
        <div
          className="container-fluid px-0"
          style={{ backgroundColor: "#F6F3FF" }}
        >
          <div
            style={{ padding: "5px", paddingLeft: "14px", paddingTop: "16px" }}
          >
            <h6 style={{ color: "#5B489D", fontWeight: "700" }}>NOTE</h6>
            <p
              style={{
                fontStyle: "italic",
                fontSize: "16px",
                fontWeight: "700",
              }}
            >
              *Kindly preview your uploaded documents before submitting them.
              Documents you have submitted cannot be deleted, edited, or altered
              by you once uploaded. If any changes are required, you will have
              to request those changes from the operations team for correction
              or editing.{" "}
            </p>
          </div>
        </div>
        <br />
        <div
          className="container-fluid p-0"
          style={{
            borderRadius: "7px",
            border: "1px solid #6a6a6a",
            backgroundColor: "white",
          }}
        >
          <div className="order-main-list d-flex justify-content-start align-items-start">
            <h4
              style={{
                padding: "8px 2px 4px 0px",
                marginLeft: "12px",
                color: "#6a6a6a",
                fontSize: "15px",
                borderBottom: "4px solid #5B489D",
              }}
            >
              STEP{" "}
              {currentStep === 1
                ? 1
                : currentStep === 2
                ? 2
                : currentStep === 3
                ? 3
                : currentStep === 4
                ? 4
                : 5}
            </h4>
          </div>
        </div>

        <div className="exec-top-circle-main container-fluid mt-4">
          <div className="progress-bar">
            <div
              className="progress-line"
              style={{
                width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
              }}
            ></div>

            {steps.map((step, index) => (
              <div key={step} className="step-container">
                <div
                  className={`step-number ${
                    index + 1 <= currentStep ? "active" : ""
                  }`}
                >
                  {`0${step}`}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* STEPS DETAILS  */}
        <div>
          {currentStep === 1 ? (
            <ExecutionAndDocumentationMobileStep1
              getDocument={getDocument}
              documentResponse={documentResponse}
            />
          ) : currentStep === 2 ? (
            <ExecutionAndDocumentationMobileStep2
              getDocument={getDocument}
              documentResponse={documentResponse}
            />
          ) : currentStep === 3 ? (
            <ExecutionAndDocumentationMobileStep3
              getDocument={getDocument}
              documentResponse={documentResponse}
            />
          ) : currentStep === 4 ? (
            <ExecutionAndDocumentationMobileStep4
              getDocument={getDocument}
              documentResponse={documentResponse}
            />
          ) : currentStep === 5 ? (
            <ExecutionAndDocumentationMobileStep5
              getDocument={getDocument}
              documentResponse={documentResponse}
            />
          ) : null}
        </div>

        <div className="buttons" style={{ textAlign: "end" }}>
          <button onClick={handlePrev} disabled={currentStep === 1}>
            Previous
          </button>
          <button onClick={handleNext} disabled={currentStep === steps.length}>
            Next
          </button>
        </div>

        <h1 className="heading mb-4" style={{ margin: "0px" }}>
          Documents
        </h1>

        <table
          style={{
            border: "1px solid #DEE2E6",
            borderRadius: "7.5px",
            overflow: "hidden",
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: "0",
            marginBottom: "12px",
          }}
        >
          <thead>
            <tr
              style={{
                borderBottom: "1px solid #DEE2E6",
                backgroundColor: "#F8F9FA",
              }}
            >
              <th
                style={{
                  width: "50%",
                  padding: "10px",
                  textAlign: "left",
                  fontSize: "14px",
                  fontWeight: "660px",
                  color: "#6A6A6A",
                }}
              >
                Sales Co-ordinator
              </th>
              <td style={{ padding: "10px", backgroundColor: "white" }}>
                {orderRelocation.Name}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th
                style={{
                  padding: "10px",
                  textAlign: "left",
                  fontSize: "14px",
                  fontWeight: "660px",
                  color: "#6A6A6A",
                }}
              >
                Operations Co-ordinator
              </th>
              <td style={{ padding: "10px" }}>
                {orderRelocation.Assigned_By_Coordinator}
              </td>
            </tr>
          </tbody>
        </table>

        {Array.isArray(rows) &&
          rows.map((row, index) => (
            <>
              <table style={rowColorChange(index)}>
                <thead>
                  <tr style={rowColorChange(index)}>
                    <th
                      style={rowColorChange(index)}
                    >
                     <span style={{
                        color: "#6A6A6A",
                        fontWeight: "700",
                        fontSize: "15px",
                      }}>

                     {String(index + 1).padStart(2, "0")}{" "}
                      {row.DocumentTypeName}
                     </span> 
                    </th>
                    <td style={{ textAlign: "right" }}>
                      <a
                        style={{
                          color: "#6a6a6a",
                          textDecoration: "none",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                        target="_blank"
                        href={`${baseImageURL}Images/Documents/${row.relocation_id}/${row.doc_name}`}
                        rel="noopener noreferrer"
                      >
                        <FontAwesomeIcon
                          icon={faArrowUpRightFromSquare}
                          style={{
                            padding: "5px 4px 0px 11px",
                            color: "#5B489D",
                          }}
                        />
                      </a>
                    </td>
                  </tr>
                </thead>
                <hr style={{ width: "114%", marginLeft: "3%" }} />
              </table>
              <table className="table" style={rowColorChange(index)}>
                <tbody>
                  <tr>
                    <td style={rowColorChange(index)}>
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: "660px",
                          color: "#878787",
                        }}
                      >
                        Status
                      </span>
                    </td>
                    <td style={rowColorChange(index)}>
                      <span>:</span>
                      {row.is_verified === 0 ? (
                        <span
                          style={{
                            color: "red",
                            fontSize: "14px",
                            fontWeight: "600",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faTimes} // Cross icon
                            style={{ marginRight: "8px" }}
                          />
                          Not Verified
                        </span>
                      ) : (
                        <span
                          style={{
                            color: "green",
                            fontSize: "14px",
                            fontWeight: "600",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faCheck} // Check icon
                            style={{ marginRight: "8px" }}
                          />
                          Verified
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td style={rowColorChange(index)}>
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: "660px",
                          color: "#878787",
                        }}
                      >
                        Upload Date & Time
                      </span>
                    </td>
                    <td style={rowColorChange(index)}>
                      <span
                        style={{
                          color: "#6A6A6A",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        :{formatDate(row.createdDate)}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style={rowColorChange(index)}>
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: "660px",
                          color: "#878787",
                        }}
                      >
                        Uploaded By
                      </span>
                    </td>
                    <td style={rowColorChange(index)}>
                      <span
                        style={{
                          color: "#6A6A6A",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        :{row.createdBy}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style={rowColorChange(index)}>
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: "660px",
                          color: "#878787",
                        }}
                      >
                        Remark
                      </span>
                    </td>
                    <td style={rowColorChange(index)}>
                      <span
                        style={{
                          color: "#6A6A6A",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        :{row.remark}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          ))}
      </div>
    </div>
  );
}

export default ExecutionAndDocumentationMobileView;
